// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"27b4e051","879":"a6d8858f"}[chunkId] + ".chunk.js";
};